// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import releaseDistributionEntity from './entities/release-distribution.json';
import releaseDistributionMenu from '../pages/release-distribution/menu.json';
import releaseDistributionFullForm from '../pages/release-distribution/forms/full.json';
import releaseDistributionContextForm from '../pages/release-distribution/forms/context.json';
import releaseDistributionMiniForm from '../pages/release-distribution/forms/mini.json';
import releaseDistributionLookupForm from '../pages/release-distribution/forms/lookup.json';
import releaseDistributionTableView from '../pages/release-distribution/views/table.json';
import releaseDistributionCardsView from '../pages/release-distribution/views/cards.json';
import releaseDistributionCalendarView from '../pages/release-distribution/views/calendar.json';
import releaseDistributionDashboardView from '../pages/release-distribution/views/dashboard.json';

/** Тип запису «Розсилка релізу» зі сторінками пакета: меню, форми та подання з pages/release-distribution/. */
export const releaseDistributionDefinition: IRecordTypeDefinition = {
  ...releaseDistributionEntity,
  views: assembleViewSet({
      table: releaseDistributionTableView,
      cards: releaseDistributionCardsView,
      calendar: releaseDistributionCalendarView,
      dashboard: releaseDistributionDashboardView,
  }),
  form: releaseDistributionFullForm,
  forms: { full: releaseDistributionFullForm, context: releaseDistributionContextForm, mini: releaseDistributionMiniForm, lookup: releaseDistributionLookupForm },
  menu: releaseDistributionMenu,
} as IRecordTypeDefinition;
